export const green = {
  1: { value: { base: '{colors.green.light.1}', _dark: '{colors.green.dark.1}' } },
  2: { value: { base: '{colors.green.light.2}', _dark: '{colors.green.dark.2}' } },
  3: { value: { base: '{colors.green.light.3}', _dark: '{colors.green.dark.3}' } },
  4: { value: { base: '{colors.green.light.4}', _dark: '{colors.green.dark.4}' } },
  5: { value: { base: '{colors.green.light.5}', _dark: '{colors.green.dark.5}' } },
  6: { value: { base: '{colors.green.light.6}', _dark: '{colors.green.dark.6}' } },
  7: { value: { base: '{colors.green.light.7}', _dark: '{colors.green.dark.7}' } },
  8: { value: { base: '{colors.green.light.8}', _dark: '{colors.green.dark.8}' } },
  9: { value: { base: '{colors.green.light.9}', _dark: '{colors.green.dark.9}' } },
  10: { value: { base: '{colors.green.light.10}', _dark: '{colors.green.dark.10}' } },
  11: { value: { base: '{colors.green.light.11}', _dark: '{colors.green.dark.11}' } },
  12: { value: { base: '{colors.green.light.12}', _dark: '{colors.green.dark.12}' } },
  a1: { value: { base: '{colors.green.light.a1}', _dark: '{colors.green.dark.a1}' } },
  a2: { value: { base: '{colors.green.light.a2}', _dark: '{colors.green.dark.a2}' } },
  a3: { value: { base: '{colors.green.light.a3}', _dark: '{colors.green.dark.a3}' } },
  a4: { value: { base: '{colors.green.light.a4}', _dark: '{colors.green.dark.a4}' } },
  a5: { value: { base: '{colors.green.light.a5}', _dark: '{colors.green.dark.a5}' } },
  a6: { value: { base: '{colors.green.light.a6}', _dark: '{colors.green.dark.a6}' } },
  a7: { value: { base: '{colors.green.light.a7}', _dark: '{colors.green.dark.a7}' } },
  a8: { value: { base: '{colors.green.light.a8}', _dark: '{colors.green.dark.a8}' } },
  a9: { value: { base: '{colors.green.light.a9}', _dark: '{colors.green.dark.a9}' } },
  a10: { value: { base: '{colors.green.light.a10}', _dark: '{colors.green.dark.a10}' } },
  a11: { value: { base: '{colors.green.light.a11}', _dark: '{colors.green.dark.a11}' } },
  a12: { value: { base: '{colors.green.light.a12}', _dark: '{colors.green.dark.a12}' } },
}
